'use-client';
import WTwitterTweet from '../../WTwitterTweet';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';

export default WithConsentPolicy(WTwitterTweet, {
  componentConsentPolicy: { analytics: true },
});
